/* eslint-disable */

import React, { useState } from "react";
import moment from "moment";
import APIClient from "../client";
import { Spinner } from "react-bootstrap";

import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  flexRender,
  createColumnHelper,
} from "@tanstack/react-table";
// import { CSVLink } from "react-csv";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";

class Jobs extends React.Component {
  static defaultProps = {
    columns: ["external_service_id", "machines", "records", "date", "status"],
  };

  state = {
    jobs: null,
  };

  constructor(props, context) {
    super(props, context);
    this.loadJobs();
  }

  async downloadJob(jobId) {
    try {
      const response = await APIClient.get(
        "/api/data/jobs/" + jobId + "/download/",
        null,
        cropr.cloudfarm_oauth_token
      );
      window.open(response, "_blank");
    } catch {
      cropr.notify("danger", gettext("Jobs could not be loaded."));
    }
  }

  async loadJobs() {
    try {
      const response = await APIClient.get(
        "/api/data/jobs/",
        { online_service: this.props.online_service },
        cropr.cloudfarm_oauth_token
      );
      this.setState({ jobs: response });
    } catch {
      cropr.notify("danger", gettext("Jobs could not be loaded."));
    }
  }

  render() {
    if (!this.state.jobs) {
      return (
        <div className="text-center m-5">
          <Spinner animation="border" role="status">
            <span className="sr-only mx-auto">Loading...</span>
          </Spinner>
        </div>
      );
    }

    if (this.state.jobs.length === 0) {
      return <div className="text-center m-5">{gettext("No jobs found for this account.")}</div>;
    }

    return (
      <JobsTable
        jobs={this.state.jobs}
        columns={this.props.columns}
        downloadJob={(id) => this.downloadJob(id)}
      />
    );
  }
}

const JobsTable = ({ jobs, columns, downloadJob }) => {
  const [sorting, setSorting] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const columnHelper = createColumnHelper();

  const getColumnDef = (columnName) => {
    switch (columnName) {
      case "external_service_id":
        return columnHelper.accessor("external_service_id", {
          header: "ID",
          cell: (info) => (
            <a
              href="#"
              className="w-100 d-inline-block overflow-hidden text-truncate"
              title={info.getValue()}
              onClick={() => downloadJob(info.row.original.id)}
            >
              {info.getValue()}
            </a>
          ),
        });
      case "machines":
        return columnHelper.accessor(
          (row) => row.machines.map((m) => cropr.getDeviceName(m)).join(", "),
          {
            id: "machines",
            header: gettext("Machines"),
          }
        );
      case "records":
        return columnHelper.accessor((row) => row.task_ids || [], {
          id: "records",
          header: gettext("Records"),
          cell: (info) => {
            const taskIds = info.getValue();
            return taskIds.map((r, i) => (
              <React.Fragment key={i}>
                {i > 0 ? ", " : null}
                {cropr.records.get(parseInt(r)) ? (
                  <a href={"/cropr/record/record/#edit/" + r} target="_blank">
                    {r}
                  </a>
                ) : (
                  r
                )}
              </React.Fragment>
            ));
          },
        });
      case "date":
        return columnHelper.accessor((row) => row.received_datetime || row.send_datetime, {
          id: "date",
          header: gettext("Date"),
          cell: (info) => moment(info.getValue()).format("YYYY-MM-DD HH:mm:ss"),
        });
      case "status":
        return columnHelper.accessor("status_text", {
          header: gettext("Status"),
          cell: (info) => {
            const statusText = info.getValue();
            return (
              <span title={cf_job_states[statusText] ? cf_job_states[statusText].description : ""}>
                {gettext(statusText)}
              </span>
            );
          },
        });
      default:
        return null;
    }
  };

  const tableColumns = columns.map(getColumnDef).filter(Boolean);

  // Add hidden ID column
  tableColumns.unshift(
    columnHelper.accessor("id", {
      header: "ID",
      enableHiding: true,
    })
  );

  const table = useReactTable({
    data: jobs,
    columns: tableColumns,
    state: {
      sorting,
      globalFilter,
      pagination,
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  // // Prepare CSV data
  // const csvHeaders = tableColumns
  //   .filter((col) => col.id !== "id") // Exclude hidden ID column
  //   .map((col) => ({
  //     label: typeof col.header === "function" ? col.header() : col.header,
  //     key: col.id,
  //   }));

  // // Transform data for CSV export
  // const csvData = jobs.map((job) => {
  //   const row = {};

  //   // Handle external_service_id
  //   if (job.external_service_id) {
  //     row.external_service_id = job.external_service_id;
  //   }

  //   // Handle machines
  //   if (job.machines) {
  //     row.machines = job.machines.map((m) => cropr.getDeviceName(m)).join(", ");
  //   }

  //   // Handle records
  //   if (job.task_ids) {
  //     row.records = job.task_ids.join(", ");
  //   }

  //   // Handle date
  //   row.date = moment(job.received_datetime || job.send_datetime).format("YYYY-MM-DD HH:mm:ss");

  //   // Handle status
  //   row.status_text = job.status_text ? gettext(job.status_text) : "";

  //   return row;
  // });

  // // CSV filename
  // const csvFilename = `jobs-export-${new Date().toISOString().slice(0, 10)}.csv`;

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <div className="dataTables_filter">
          <input
            className="form-control"
            placeholder={gettext("Search")}
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />
        </div>
        <div className="dataTables_filter">
          {/* <CSVLink
            data={csvData}
            headers={csvHeaders}
            filename={csvFilename}
            className="btn btn-default btn-sm"
            target="_blank"
          >
            {gettext("Export to CSV")}
          </CSVLink> */}
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    style={{
                      cursor: header.column.getCanSort() ? "pointer" : "default",
                    }}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(header.column.columnDef.header, header.getContext())}
                    {{
                      asc: " ^",
                      desc: " v",
                    }[header.column.getIsSorted()] ?? ""}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="d-flex justify-content-between">
        <div className="d-flex gap-2 align-items-center">
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
          >
            {"<<"}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            {"<"}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            {">"}
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            {">>"}
          </button>
          <span>
            {gettext("Page")} {table.getState().pagination.pageIndex + 1} {gettext("of")}{" "}
            {table.getPageCount()}
          </span>
        </div>
        <select
          className="form-select form-select-sm w-auto"
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {gettext("Show")} {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

const cf_job_states = {
  "Error sending": {
    text: gettext("Error sending"),
    description: gettext("An error occurred when sending this job."),
  },
  Send: { text: gettext("Sent"), description: gettext("Job has been sent.") },
  Pending: {
    text: gettext("Pending"),
    description: gettext("Job is pending to be sent to the tractor."),
  },
  "Conversion failed": {
    text: gettext("Conversion failed"),
    description: gettext("The task could not be converted to the appropriate format."),
  },
  Queued: {
    text: gettext("Queued"),
    description: gettext("Job is queued for downloading by the tractor."),
  },
  Processing: { text: gettext("Processing"), description: gettext("Job is being processed.") },
  Failed: { text: gettext("Failed"), description: gettext("Job transfer has failed.") },
  Delivered: {
    text: gettext("Delivered"),
    description: gettext("Job has been delivered to the tractor."),
  },
  Canceled: { text: gettext("Canceled"), description: gettext("Job has been canceled.") },
  "Error receiving": {
    text: gettext("Error receiving"),
    description: gettext("An error occurred receiving task data."),
  },
  Received: {
    text: gettext("Received"),
    description: gettext("Task data has been received from the tractor."),
  },
  Expired: { text: gettext("Expired"), description: gettext("Task has timed out.") },
};

export default Jobs;
